import type { Copy } from "../types";

export const fr: Copy = {
    seo: {
      title: "Calculateur d'âge du véhicule | par année et mois",
      description:
        "Vérifiez l'âge exact d'un véhicule à partir de son année et mois de fabrication. Voir années, mois, jours, total et jalons en un seul outil.",
      keywords: ["calculateur âge véhicule", "âge voiture", "âge véhicule", "date de fabrication"],
      faq: [
        {
          question: "Que fait ce calculateur ?",
          answer: "Il calcule l'âge exact d'un véhicule à partir de l'année et du mois de fabrication choisis.",
        },
        {
          question: "Pourquoi un mois optionnel ?",
          answer: "Le mois rend le calcul plus précis. Sans mois, janvier est utilisé.",
        },
        {
          question: "Puis-je choisir une année ou un mois futur ?",
          answer: "Non. Les années futures sont bloquées et les mois futurs sont désactivés pour l'année en cours.",
        },
      ],
    },
    headerTagline: "Utilitaire véhicule",
    headerTitle: "Calculateur d'âge",
    reset: "Réinitialiser",
    switchToLight: "Mode clair",
    switchToDark: "Mode sombre",
    languageLabel: "Langue",
    languageEnglish: "Anglais",
    languageHindi: "Hindi",
    heroEyebrow: "Âge du véhicule, clairement",
    heroTitle: "Un outil simple pour l'âge du véhicule.",
    heroDescription: "Choisissez l'année de fabrication. Ajoutez un mois si vous voulez plus de précision.",
    yearSelectLabel: "Année de fabrication",
    monthSelectLabel: "Mois de fabrication",
    includeMonthLabel: "Inclure un mois précis pour plus de précision",
    includeMonthNote: "Sans mois, janvier est utilisé pour le calcul.",
    yearOnlyBadge: "Année seule",
    yearMonthBadge: "Année + mois",
    yearPlaceholder: "Choisir l'année",
    monthPlaceholder: "Choisir le mois",
    inputTitle: "Année de fabrication",
    inputLabel: "Année de fabrication",
    blockedDateNote: "Les années futures sont bloquées.",
    result: "Résultat",
    vehicleAgeLead: "Votre véhicule est",
    asOfToday: "À ce jour",
    years: "Années",
    months: "Mois",
    days: "Jours",
    totalDays: (count) => `${count.toLocaleString("en-IN")} jours au total`,
    ageLabels: { almostNew: "Presque neuf", modern: "Moderne", mature: "Mûr", classic: "Classique" },
    estimatedValue: {
      high: "Fort potentiel de revente",
      healthy: "Bonne conservation de la valeur",
      moderate: "Dépréciation modérée",
      collector: "L'intérêt des collectionneurs peut croître",
    },
    maintenanceTitle: "Entretien",
    maintenance: {
      routine: "Entretien courant et soin OEM",
      watch: "Surveillez freins, fluides et pneus",
      plan: "Prévoyez les pièces d'usure et les contrôles",
      specialized: "L'entretien spécialisé prend de la valeur",
    },
    registrationTitle: "Immatriculation",
    registration: {
      collector: "Peut bénéficier d'un statut collection dans certaines régions",
      classic: "Le statut voiture ancienne peut s'appliquer",
      standard: "Attendez-vous aux renouvellements standards et contrôles",
      regular: "L'immatriculation normale s'applique généralement",
    },
    upcomingMilestoneTitle: "Prochain jalon",
    milestoneTimelineTitle: "Chronologie des jalons",
    milestoneRemaining: ({ label, days }) => `${label} dans ${days.toLocaleString("fr-FR")} jours`,
    reached: "Atteint",
    upcoming: "À venir",
    allMilestonesReachedTitle: "Tous les jalons affichés sont atteints",
    allMilestonesReachedBody: "Ce véhicule a dépassé la plage de jalons affichée.",
    copySummary: "Copier le résumé",
    shareResult: "Partager le résultat",
    resetMessage: "Calculateur réinitialisé",
    summaryCopied: "Résumé copié dans le presse-papiers",
    clipboardFailed: "Accès au presse-papiers impossible",
    emptyTitle: "Choisissez une année de fabrication pour voir le détail",
    emptyDescription:
      "Vous verrez l'âge exact, le total de jours, l'entretien et les jalons une fois l'année choisie.",
    shareTitle: "Calculateur d'âge du véhicule",
    summary: ({ label, years, months, days, asOf }) =>
      `Mon véhicule a été fabriqué en ${label} et a ${years} ans, ${months} mois et ${days} jours au ${asOf}.`,
    milestones: {
      1: { label: "Première année", note: "Utile pour la garantie et l'entretien." },
      3: { label: "Trois ans", note: "Point courant pour la revente et la valeur." },
      5: { label: "Cinq ans", note: "Bon moment pour le budget entretien." },
      10: { label: "Dix ans", note: "Les composants vieillissants demandent de l'attention." },
      15: { label: "Quinze ans", note: "Le statut classique peut commencer." },
      25: { label: "Vingt-cinq ans", note: "Attrait collection et import possible." },
    },
  };
